import * as z from "zod";

export const requiredSelectValue = z
  .string({
    required_error: "Please select a value",
    invalid_type_error: "Please select a value",
  })
  .min(1, "Please select a value");

export const requiredNumberField = (schema: z.ZodNumber) =>
  z.preprocess((value) => {
    if (value === null || value === "" || typeof value === "undefined") {
      return undefined;
    }

    if (typeof value === "number" && Number.isNaN(value)) {
      return undefined;
    }

    return value;
  }, schema);

export const optionalPartialAttributes = (attributesSchema: z.ZodObject<any>) =>
  z.preprocess((val) => {
    if (!val || typeof val !== "object") {
      return undefined;
    }

    const cleaned = Object.fromEntries(
      Object.entries(val as Record<string, unknown>).filter(
        ([, value]) => value !== null && value !== "" && value !== undefined
      )
    );

    return Object.keys(cleaned).length > 0 ? cleaned : undefined;
  }, attributesSchema.partial().optional());

export const filterSyncArray = (
  val: unknown,
  isComplete: (item: Record<string, unknown>) => boolean,
  key: "sync" | "connect" = "sync"
) => {
  if (!val || typeof val !== "object") {
    return [];
  }

  const items = (val as Record<string, unknown>)[key];
  if (!Array.isArray(items)) {
    return [];
  }

  return items.filter(
    (item): item is Record<string, unknown> =>
      !!item && typeof item === "object" && isComplete(item)
  );
};

export const optionalProductionRateType = z.preprocess((value) => {
  if (value === null || value === undefined || value === "") {
    return undefined;
  }

  if (typeof value === "boolean") {
    return value;
  }

  if (value === "TONS_PER_HOUR") {
    return true;
  }

  if (value === "SQ_FT_SQ_YD_PER_HOUR") {
    return false;
  }

  return value;
}, z.boolean().nullish());

export const optionalExternalProductName = z.null().or(z.string().optional());
